import Code from "./Code"
import Header from "./Header"
import Result from "./Result";

const Home = () => {
    return(
        <>
            <Header/>
            <Code/>
            <Result/>
        </>
    )
}
export default Home;